import React from 'react';
import { Warehouse, Package, ShieldCheck, Clock } from 'lucide-react';

const services = [
  {
    icon: Warehouse,
    title: 'Grain Storage',
    description: 'Modern, secure grain storage facilities with capacity to meet your harvest needs.'
  },
  {
    icon: Package,
    title: 'Container Packing',
    description: 'Professional container packing services for export at our Wycheproof packing site.'
  },
  {
    icon: ShieldCheck,
    title: 'Quality Assurance',
    description: 'Strict quality control measures to ensure your grain maintains premium standards.'
  },
  {
    icon: Clock,
    title: 'Reliable Service',
    description: 'Decades of experience serving growers throughout Victoria with trusted expertise.'
  }
];

const Services = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Comprehensive grain handling solutions tailored to meet the needs of Victoria's farming community.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 border-2 border-yellow-500 rounded-lg flex items-center justify-center mb-5 bg-yellow-50">
                  <IconComponent className="w-7 h-7 text-yellow-500" strokeWidth={1.5} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
